<template>
    <Forms ref="searchReports"
            :title="'Filtrar dados'"
            :showHelp="true"
            :showClearButtonIcon="true"
            :ShowFooterImbo="true"
            :showSearchIcon="true"
            :showSearchButtonIcon="true"
            v-on:Clear="Clear"
            v-on:Search="Search"
            v-on:Load ="onLoad"
          >
        <div>
          <div id="form-search">
              <label class="labelseach">Patologias</label>
              <multiselect v-model="patologiaInternoArray"  :multiple="true"  :taggable="true" placeholder="Selecione uma Patologia" :options="patologiaArray" label="text" @tag="addTag" track-by="value" :close-on-select="false">
              </multiselect>

              <label  class="labelseach mt-3">Empreendimento</label>

              <multiselect v-model="empreendimentoInternoArray"  :multiple="true"  :taggable="true" placeholder="Selecione uma Patologia" :options="empreendimentoArray" label="nomeEmpreendimento" @tag="addTag" track-by="id" :close-on-select="false">
              </multiselect>

              <!-- <b-form-select v-model="formSearch.enterprise">
                <template slot="first">
                  <option disabled :value= "''" >Selecione um empreendimento</option>
                  <option v-for="data in empreendimentoArray" v-bind:key="data.id" :value="data.id">{{data.nome}}</option>
                </template>
              </b-form-select> -->
              <!-- <label  class="labelseach mt-3">Status do Chamado</label>
              <select v-model="formSearch.StatusOcorrencia" name="statusChamado" class="form-control" id="exampleFormControSelect2">
                <option v-for="data in statusocorrencia" v-bind:key="data.value" :value="data.value">{{data.text}}</option>
              </select> -->
              <label  class="labelseach mt-3">Status do Chamado</label>
              <select v-model="formSearch.statusOcorrencia" name="statusChamado" class="form-control" id="exampleFormControSelect2">
                <option :value="null">Selecione</option>
                <option v-for="data in statusocorrencia" v-bind:key="data.value" :value="data.value">{{data.text}}</option>
              </select>

              <label class="labelseach mt-3">Período</label>
              <div class="periodos">
                  <button id="semanal" class="btn-periodos"  v-on:click="filter">SEMANAL</button>
                  <button id="mensal"  class="btn-periodos" v-on:click="filter">MENSAL</button>
                  <button id="anual" class="btn-periodos" v-on:click="filter">ANUAL</button>
                  <button id="personalizado" class="btn-periodos" v-on:click="filter">PERSONALIZADO</button>
              </div>
              <div class="d-flex align-items-end mt-3" v-if="dataspersonalizadas">
                <b-form-datepicker
                    ref = "DataInicio"
                    v-model ="formSearch.dataInicio"
                    placeholder="__/__/__"
                    locale="pt-BR"
                    :date-format-options="{ year: '2-digit', month: 'numeric', day: 'numeric' }"
                ></b-form-datepicker>

                <label class="labelseach ml-1 mr-1" > à </label>
                <b-form-datepicker
                    v-model ="formSearch.dataFinal"
                    placeholder="__/__/__"
                    locale="pt-BR"
                    :date-format-options="{ year: '2-digit', month: 'numeric', day: 'numeric' }"
                ></b-form-datepicker>
                </div>
          </div>
        </div>
    </Forms>

</template>

<script>
import searchTotalCost from './searchTotalCost'
export default searchTotalCost
</script>

<style scoped>
.margem{
  margin-bottom: 7%;
}

#form-search{
  display: flex;
  flex-direction: column;
  align-content: center;
}

/* .labelseach{
  font: normal normal normal 16px/21px Segoe UI;
  letter-spacing: 0px;
  color: #2A2A2A;

} */

.labelseach{
  font-weight: bold;
  color: #666666;
  font-size: 14px;
  margin-bottom: 5px;
  padding-bottom: 0px;
  font-family: 'Segoe UI';
  /* margin:10px 0; */
}

.btn-periodos{
  background-color: #EBEBEB;
  height: 30px;
  margin-top: 5px;
  margin-bottom: 5px;
  width: 130px;
  font-weight: bold;
  color: grey;
  border-radius: 25px;
  padding: 5px;
  border: 1px solid rgb(77, 77, 77);
  font-family: 'Segoe UI';
}
.btn-periodos:focus{
   background-color: #008148;
  height: 30px;
  margin-top: 5px;
  margin-bottom: 5px;
  width: 130px;
  font-weight: bold;
  color: white;
  border-radius: 25px;
  padding: 5px;
  border: 1px solid rgb(77, 77, 77);
  font-family: 'Segoe UI';
}

.btn-periodos-active{
   background-color: #008148;
  height: 30px;
  margin-top: 5px;
  margin-bottom: 5px;
  width: 130px;
  font-weight: bold;
  color: white;
  border-radius: 25px;
  padding: 5px;
  border: 1px solid rgb(77, 77, 77);
  font-family: 'Segoe UI';
}

.periodos {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  column-gap: 1rem;
}

#app.zopone .text-third{

  font-size: 16px;
  font-weight: normal;

}

.periodos-container{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/totalCost/components/searchTotalCost/searchTotalCost.vue